import {observable} from "mobx";
import {RelatorioService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";
import fileDownload from "../../comum/components/FileDownload";

export default class SisMotStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.relatorioService = new RelatorioService();
    }

    onExportExcel = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadSisMotExcel(filtro).then(response => {
            fileDownload(response.data, "Relatório Sis_Mot.xlsx");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }

}
